// extracted by mini-css-extract-plugin
module.exports = {"font":"\"Montserrat\",sans-serif"};